import { render } from "./lsbs_create_update_plan_packet.vue?vue&type=template&id=2115d6c4&scoped=true"
import script from "./lsbs_create_update_plan_packet.vue?vue&type=script&lang=js"
export * from "./lsbs_create_update_plan_packet.vue?vue&type=script&lang=js"

import "./lsbs_create_update_plan_packet.vue?vue&type=style&index=0&id=2115d6c4&scoped=true&lang=css"

import exportComponent from "D:\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2115d6c4"]])

export default __exports__